<h2 mat-dialog-title>Select Bank Account</h2>

<form [formGroup]="form" (ngSubmit)="onConfirm()" autocomplete="off">
	<mat-dialog-content>
		<p class="intro">
			Loan {{ data.promise.loanNumber }} has no active bank account. Choose
			which account to charge.
		</p>

		<dl class="context">
			<dt>Amount</dt>
			<dd>{{ FormatUtil.formatCurrency(data.promise.amount) }}</dd>
			<dt>Promise Date</dt>
			<dd>{{ data.promise.promiseDate }}</dd>
		</dl>

		<mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
		<p class="load-error" *ngIf="loadError">{{ loadError }}</p>

		<formly-form
			*ngIf="!isLoading && !loadError"
			[form]="form"
			[fields]="fields"
			[model]="model"
		></formly-form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()">
			Cancel
		</button>
		<button
			mat-raised-button
			color="primary"
			type="submit"
			[disabled]="isLoading || !!loadError"
		>
			Continue
		</button>
	</mat-dialog-actions>
</form>
